import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import ItemOrcamentoVendaNew from "../../orcamento_venda/orcamentovenda-incluiritens.new";

const ModalItemOrcamentoVendaControl = (props) => {

    const { modal, toggle, className } = props;

    return (
        <>
            <Modal
                size="xl"
                centered
                show={modal}
                onHide={toggle}
                className={className}
            >
                <ModalHeader toggle={toggle} closeButton></ModalHeader>
                <ModalBody>
                    <ItemOrcamentoVendaNew {...props} />
                </ModalBody>
            </Modal>
        </>
    )
}

export default ModalItemOrcamentoVendaControl;